/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconRotateOutline = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-rotate-outline',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "M23 4v6h-6", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
});
IconRotateOutline.displayName = 'IconRotateOutline';
export default IconRotateOutline;
